import { ComponentPropsWithoutRef, FC, memo } from 'react';
import { useAutoSendProductOrganization } from '../../../../../store/reducers/autoSendProduct';
import { Avatar } from '@sravni/react-design-system';
import { Typography } from '@sravni/react-design-system';
import { Icon } from '@sravni/react-design-system';
import { StarFilled } from '@sravni/react-icons';
import styles from './organization.module.scss';
import classNames from 'classnames';

const { Text } = Typography;

type Props = ComponentPropsWithoutRef<'div'>;

export const OrganizationComponent: FC<Props> = (props) => {
    const { className } = props;
    const organization = useAutoSendProductOrganization();

    if (!organization) {
        return null;
    }

    return (
        <div className={classNames(styles['organization-container'], className)}>
            <Avatar size={60} src={organization.logotypes?.square} className={styles['logo']} />
            <div>
                <Text className={styles['organization-name']} size={16}>
                    {organization.name?.accusative}
                </Text>
                {organization.ratings?.sravniRuRating && (
                    <div className={styles['organization-rate']}>
                        <Icon icon={<StarFilled />} className={styles['organization-rate__star']} />
                        <Text size={12}>{organization.ratings.sravniRuRating}</Text>
                    </div>
                )}
            </div>
        </div>
    );
};

export const Organization = memo(OrganizationComponent);
